module.exports = __webpack_public_path__ + "media/src/pages/Card/images/bigBall-7f61664fc9d66ce1946de7e6e336db26.svg";